import { useEffect, useState } from 'react';
import { useFieldArray } from 'react-hook-form';
import { useBlocker } from 'react-router-dom';
import {
  useGetRespondentImpactQuery,
} from 'store/slices/survey/apis/surveyApi';

import { COEFFICIENT, COEFFICIENT_KEY } from '../../../constants/formFields';
import { BLOCKER_STATES } from '../../../constants/general';
import { useSetAdminRespondentImpactMutation } from '../../../store/slices/adminUsers/apis/adminUsersApi';
import useInsightsDashboardForm from './hooks/useSettingWeightingForm';
import SettingWeightingView from './SettingWeightingView';

function SettingWeighting() {
  const [isBackModalOpen, setIsBackModalOpen] = useState(false);

  const {
    control,
    reset,
    setValue,
    isDirty,
    watch,
  } = useInsightsDashboardForm();

  const { fields, update } = useFieldArray({
    control,
    name: COEFFICIENT,
    keyName: COEFFICIENT_KEY,
  });

  const { coefficient } = watch();

  const { data: coefficientData = [] } = useGetRespondentImpactQuery(
    { companyId: undefined },
  );

  const [setRespondentImpact, { isLoading: isSetImpactLoading }] = useSetAdminRespondentImpactMutation();

  const handleSaveCoefficients = async () => {
    await setRespondentImpact({ impacts: coefficient || [] }).unwrap();
    reset({ [COEFFICIENT]: coefficient || [] });
  };

  const onHandleBackConfirm = () => {
    setIsBackModalOpen(false);
    reset();
  };

  const blocker = useBlocker(({ currentLocation, nextLocation }) => isDirty
    && currentLocation.pathname !== nextLocation.pathname && !isBackModalOpen);

  useEffect(() => {
    if (blocker.state === BLOCKER_STATES.blocked) {
      if (isDirty) {
        setIsBackModalOpen(true);
      } else {
        blocker.proceed?.();
      }
    }
  }, [blocker, isDirty]);

  useEffect(() => {
    setValue(
      COEFFICIENT,
      coefficientData.map((item) => ({ id: item.id, impact: +item.impact })) ?? [],
    );
  }, [coefficientData, setValue]);

  return (
    <SettingWeightingView
      control={control}
      coefficientData={coefficientData}
      isBackModalOpen={isBackModalOpen}
      setIsBackModalOpen={setIsBackModalOpen}
      fields={fields}
      update={update}
      onSaveCoefficients={handleSaveCoefficients}
      isSetImpactLoading={isSetImpactLoading}
      onHandleBackConfirm={onHandleBackConfirm}
    />
  );
}

export default SettingWeighting;
